import axios from 'axios'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { OrganizationIntegrationListResponse } from 'src/models/organizationIntegration.models'
import { RootState } from 'src/redux/createRootReducer'
import { selectAuthedJsonApiRequestConfig } from 'src/redux/selectors/axios.selectors'
import { BackendErrorPayload } from 'src/utils/error.utils'

export const GET_ORG_INTEGRATIONS_INIT = 'app/GET_ORG_INTEGRATIONS_INIT'
export const GET_ORG_INTEGRATIONS_SUCCESS = 'app/GET_ORG_INTEGRATIONS_SUCCESS'
export const GET_ORG_INTEGRATIONS_FAILURE = 'app/GET_ORG_INTEGRATIONS_FAILURE'

export type GetOrgIntegrationsSuccessPayload = {
  organizationConnections: OrganizationIntegrationListResponse[]
}

export type GetOrgIntegrationsFailurePayload = BackendErrorPayload<string>

export interface GetOrgIntegrationsInitAction {
  type: typeof GET_ORG_INTEGRATIONS_INIT
}
export interface GetOrgIntegrationsSuccessAction {
  type: typeof GET_ORG_INTEGRATIONS_SUCCESS
  payload: GetOrgIntegrationsSuccessPayload
}
export interface GetOrgIntegrationsFailureAction {
  type: typeof GET_ORG_INTEGRATIONS_FAILURE
  payload: GetOrgIntegrationsFailurePayload
}

export type GetOrgIntegrationsActions =
  | GetOrgIntegrationsInitAction
  | GetOrgIntegrationsSuccessAction
  | GetOrgIntegrationsFailureAction

const createGetOrgIntegrationsInitAction =
  (): GetOrgIntegrationsInitAction => ({
    type: GET_ORG_INTEGRATIONS_INIT,
  })
const createGetOrgIntegrationsSuccessAction = (
  payload: GetOrgIntegrationsSuccessPayload,
): GetOrgIntegrationsSuccessAction => ({
  type: GET_ORG_INTEGRATIONS_SUCCESS,
  payload,
})
const createGetOrgIntegrationsFailureAction = (
  payload: GetOrgIntegrationsFailurePayload,
): GetOrgIntegrationsFailureAction => ({
  type: GET_ORG_INTEGRATIONS_FAILURE,
  payload,
})

export const getOrgIntegrations = (
  orgId: string,
): ThunkAction<Promise<void>, RootState, void, GetOrgIntegrationsActions> => {
  return async (
    dispatch: ThunkDispatch<RootState, void, GetOrgIntegrationsActions>,
    getState: () => RootState,
  ): Promise<void> => {
    dispatch(createGetOrgIntegrationsInitAction())
    return axios
      .get<GetOrgIntegrationsSuccessPayload>(
        `/organizations/${orgId}/connections`,
        selectAuthedJsonApiRequestConfig(getState()),
      )
      .then(
        (response) => {
          dispatch(createGetOrgIntegrationsSuccessAction(response.data))
        },
        (err) => {
          dispatch(createGetOrgIntegrationsFailureAction(err.response.data))
        },
      )
  }
}

export const GET_ORG_INTEGRATION_INIT = 'app/GET_ORG_INTEGRATION_INIT'
export const GET_ORG_INTEGRATION_SUCCESS = 'app/GET_ORG_INTEGRATION_SUCCESS'
export const GET_ORG_INTEGRATION_FAILURE = 'app/GET_ORG_INTEGRATION_FAILURE'

export type GetOrgIntegrationSuccessPayload = {
  organizationConnection: OrganizationIntegrationListResponse
}

export type GetOrgIntegrationFailurePayload = BackendErrorPayload<string>

export interface GetOrgIntegrationInitAction {
  type: typeof GET_ORG_INTEGRATION_INIT
}
export interface GetOrgIntegrationSuccessAction {
  type: typeof GET_ORG_INTEGRATION_SUCCESS
  payload: GetOrgIntegrationSuccessPayload
}
export interface GetOrgIntegrationFailureAction {
  type: typeof GET_ORG_INTEGRATION_FAILURE
  payload: GetOrgIntegrationFailurePayload
}

export type GetOrgIntegrationActions =
  | GetOrgIntegrationInitAction
  | GetOrgIntegrationSuccessAction
  | GetOrgIntegrationFailureAction

const createGetOrgIntegrationInitAction = (): GetOrgIntegrationInitAction => ({
  type: GET_ORG_INTEGRATION_INIT,
})
const createGetOrgIntegrationSuccessAction = (
  payload: GetOrgIntegrationSuccessPayload,
): GetOrgIntegrationSuccessAction => ({
  type: GET_ORG_INTEGRATION_SUCCESS,
  payload,
})
const createGetOrgIntegrationFailureAction = (
  payload: GetOrgIntegrationFailurePayload,
): GetOrgIntegrationFailureAction => ({
  type: GET_ORG_INTEGRATION_FAILURE,
  payload,
})

export const getOrgIntegration = (
  orgId: string,
  connectionId: string,
): ThunkAction<Promise<void>, RootState, void, GetOrgIntegrationActions> => {
  return async (
    dispatch: ThunkDispatch<RootState, void, GetOrgIntegrationActions>,
    getState: () => RootState,
  ): Promise<void> => {
    dispatch(createGetOrgIntegrationInitAction())
    return axios
      .get<GetOrgIntegrationSuccessPayload>(
        `/organizations/${orgId}/connections/${connectionId}`,
        selectAuthedJsonApiRequestConfig(getState()),
      )
      .then(
        (response) => {
          dispatch(createGetOrgIntegrationSuccessAction(response.data))
        },
        (err) => {
          dispatch(createGetOrgIntegrationFailureAction(err.response.data))
        },
      )
  }
}
